import { cn } from "@src/utils/cn"

const TokenIconPlaceholder = ({ className }: { className?: string }) => (
  <div
    className={cn(
      "-outline-offset-1 relative flex size-full items-center justify-center overflow-hidden rounded-full bg-gray-100 outline-1 outline-gray-900/10 dark:bg-gray-700 dark:outline-white/5",
      className
    )}
  >
    <div className="size-1/2 rounded-full border-2 border-gray-500 border-dashed dark:border-gray-300" />
  </div>
)

export default TokenIconPlaceholder
